/**
 * Кастомный календарь
 */
$.fn.customDatepicker = function(minDate, maxDate, lang) {
    if (typeof $.fn.datepicker !== 'undefined') {
        let $self = $(this);
        const $loader = $('.js-loader-wrapper');
        const ajaxUrl = $self.data('ajaxUrl');

        const getDatesUrl = $self.data('get-dates-url');
        let datesArray = $self.data('dates');

        const defaultParams = {
            'AJAX': true,
            'SECTION_CODE': $self.data('sectionCode')
        };
        const $newsListWrap = $('.js-news-list-wrap');

        let selectedDay = null;

        let tagId = null;

        /**
         * Получение GET-параметров из url
         * @returns {any}
         */
        const getUrlParams = function () {
            // извлекаем строку из объекта window
            var queryString = window.location.search.slice(1);

            // объект для хранения параметров
            var obj = {};
            // если есть строка запроса
            if (queryString) {
                // данные после знака # будут опущены
                queryString = queryString.split('#')[0];
                // разделяем параметры
                var arr = queryString.split('&');

                for (var i=0; i<arr.length; i++) {
                    // разделяем параметр на ключ => значение
                    var a = arr[i].split('=');
                    // обработка данных вида: list[]=thing1&list[]=thing2
                    var paramNum = undefined;
                    var paramName = a[0].replace(/\[\d*\]/, function(v) {
                        paramNum = v.slice(1,-1);
                        return '';
                    });
                    // передача значения параметра ('true' если значение не задано)
                    var paramValue = typeof(a[1])==='undefined' ? true : a[1];
                    // преобразование регистра
                    //paramName = paramName.toLowerCase();
                    //paramValue = paramValue.toLowerCase();
                    // если ключ параметра уже задан
                    if (obj[paramName]) {
                        // преобразуем текущее значение в массив
                        if (typeof obj[paramName] === 'string') {
                            obj[paramName] = [obj[paramName]];
                        }
                        if (typeof paramNum === 'undefined') {
                            obj[paramName].push(paramValue);
                        }
                        else {
                            obj[paramName][paramNum] = paramValue;
                        }
                    }
                    // если параметр не задан, делаем это вручную
                    else {
                        obj[paramName] = paramValue;
                    }
                }
            }

            return obj;
        };

        /**
         * Установка GET-параметров в url
         */
        const setUrlParams = function (paramsObject) {
            let paramsArray = [];
            for (let param in paramsObject) {
                paramsArray.push([param, paramsObject[param]]);
            }
            let pageUrl = window.location.href.split('?')[0];
            let paramsString = paramsArray.map(el => `${el[0]}=${el[1]}`).join('&');
            window.history.pushState({
                html: $newsListWrap.html(),
                pageTitle: document.title
            }, '', `${pageUrl}?${paramsString}`);
        };

        /**
         * Получение списка новостей
         * @param {Object} requestParams
         */
        const getNews = function (requestParams) {
            let params = $.extend({}, defaultParams, requestParams);
            $loader.addClass('loading');
            $newsListWrap.empty();
            $.ajax({
                url: ajaxUrl,
                data: params
            }).done(function (result) {
                $loader.removeClass('loading');
                setUrlParams(requestParams);
                $newsListWrap.html(result);
                $newsListWrap.find('.pagination a').each(function () {
                    let $link = $(this);
                    $link.attr('href', '?' + $link.attr('href').split('?')[1].replace('AJAX=true&', ''));
                });
            }).fail(function (err) {
                console.log('Не удалось загрузить список новостей', err);
            });
        };

        /**
         * Обновить список доступных дат
         * @param year
         */
        const updateDates = function(year)
        {
            let params = $.extend({}, defaultParams, {
                'YEAR': year
            });
            $.ajax({
                url: getDatesUrl,
                data: params,
                dataType: 'json'
            }).done(function (result) {
                datesArray = result;
                // обновляем календарь
                $self.datepicker('refresh');
            }).fail(function (err) {
                console.log('Не удалось обновить даты', err);
            });
        };


        const getSelectedYear = function() {
            return parseInt($('.js-select2.calendar-filter-year').val());
        };

        const getSelectedMonth = function() {
            return parseInt($('.js-select2.calendar-filter-month').val()) + 1;
        };

        let $closeBtn = $('<button>', {
            class: 'js-hide-calendar calendar-close-btn',
            type: 'button'
        });

        /**
         * Инициализация
         */
        const init = function () {

            // Если подключен select2 - добавляем выбор месяца/года
            if (typeof $.fn.select2 !== 'undefined') {
                $self.prepend($('<div>', {
                    class: 'calendar-filter js-calendar-filter',
                    append: [
                        $('<select>', {
                            class: 'js-select2 calendar-filter-month',
                            attr: {
                                'data-select2-class': 'select2-filter-month'
                            },
                            append: function () {
                                var monthArray;
                                monthArray = [
                                    'Январь',
                                    'Февраль',
                                    'Март',
                                    'Апрель',
                                    'Май',
                                    'Июнь',
                                    'Июль',
                                    'Август',
                                    'Сентябрь',
                                    'Октябрь',
                                    'Ноябрь',
                                    'Декабрь'
                                ];
                                if (lang === 'en') {
                                    monthArray = [
                                        'January',
                                        'February',
                                        'March',
                                        'April',
                                        'May',
                                        'June',
                                        'July',
                                        'August',
                                        'September',
                                        'October',
                                        'November',
                                        'December'
                                    ];
                                }

                                return monthArray.map(function (el, index) {
                                    return $('<option>', {
                                        value: index,
                                        text: el,
                                        selected: index === maxDate.getMonth()
                                    });
                                });
                            }
                        }),
                        $('<select>', {
                            class: 'js-select2 calendar-filter-year',
                            attr: {
                                'data-select2-class': 'select2-filter-year'
                            },
                            append: function () {
                                let minYear = minDate.getFullYear();
                                let maxYear = maxDate.getFullYear();
                                let optionsArray = [];

                                for (let i = minYear; i <= maxYear; i++) {
                                    optionsArray.push($('<option>', {
                                        value: i,
                                        text: i,
                                        selected: i === maxDate.getFullYear()
                                    }));
                                }

                                return optionsArray;
                            }
                        }),
                        $closeBtn
                    ]
                }));

                /**
                 * Инициализация select2 для полей выбора года/месяца
                 */
                $('.js-calendar-filter .js-select2').each(function () {
                    let $select = $(this);
                    $select.select2({
                        width: 'style',
                        dropdownParent: $select.parent(),
                        containerCssClass: $select.data('select2-class')
                    });

                    $select.on('change', function () {
                        let datepicker = $self.data('datepicker');
                        let selectedYear = getSelectedYear();
                        let selectedMonth = (parseInt($('.js-select2.calendar-filter-month').val()) + 1).toString().padStart(2, '0');
                        if (typeof datepicker !== 'undefined') {
                            datepicker.date = new Date(`${selectedYear}-${selectedMonth}-01`);
                        }

                        selectedDay = null;

                        getNews({
                            YEAR: selectedYear,
                            MONTH: selectedMonth,
                            TAG: tagId
                        });

                        if ($(this).hasClass('calendar-filter-year')) {
                            updateDates(selectedYear);
                        }
                    });

                    // Если подключен PerfectScrollbar - подключаем кастомный скролл в выпадающих списках
                    if (typeof PerfectScrollbar !== 'undefined') {
                        $select.on('select2:open', function () {
                            $('.select2-results__options').each(function (index, el) {
                                if (typeof $(el).data('ps') === 'undefined') {
                                    $(el).data('ps', new PerfectScrollbar(el, {
                                        suppressScrollX: true
                                    }));
                                }
                                setTimeout(function () {
                                    $(el).data('ps').update();
                                }, 100);
                            });
                        });
                    }
                });

                // Страница не должна скроллиться, пока скроллится список опций
                $(document).on('wheel', '.select2-results__options', function (e) {
                    e.preventDefault();
                });

                /**
                 * пагинация
                 */
                $newsListWrap.on('click', '.pagination a', function() {
                    const href = $(this).attr('href');
                    let pageData = href.match(/PAGEN_(\d+)\=(\d+)/);

                    let pager = 1;
                    let page = 1;
                    if (pageData && typeof pageData[1] !== 'undefined' && typeof pageData[2] !== 'undefined') {
                        pager = pageData[1];
                        page = pageData[2];
                    }

                    let selectedYear = getSelectedYear();
                    let selectedMonth = getSelectedMonth();

                    const pagerParam = 'PAGEN_' + pager;

                    let params = {
                        YEAR: selectedYear,
                        MONTH: selectedMonth
                    };

                    if (selectedDay) {
                        params['DAY'] = selectedDay;
                    }

                    if (tagId) {
                        params['TAG'] = tagId;
                    }

                    params[pagerParam] = page;

                    getNews(params);

                    scroll(0, 0);

                    return false;
                })
            }

            // Инициализация датапикера
            $self.datepicker({
                inline: true,
                minDate: minDate,
                maxDate: maxDate, // нельзя читать новости из будущего - у одних ребят была куча проблем из-за этого в 1985 году
                startDate: maxDate,
                toggleSelected: false,
                selectOtherMonths: false,
                onRenderCell: function (date, cellType) { // форматирование ячеек календаря
                    let dateDayString = date.getDate().toString().padStart(2, '0');
                    let dateMonthString = (date.getMonth() + 1).toString().padStart(2, '0');
                    let dateText = `${date.getFullYear()}-${dateMonthString}-${dateDayString}`;

                    if (typeof datesArray !== 'undefined' && cellType === 'day') {
                        if (datesArray.indexOf(dateText) !== -1) {
                            return {
                                classes: '-has-event-'
                            };
                        } else {
                            return {
                                disabled: true
                            };
                        }
                    }
                },
                onSelect: function (formattedDate, date) { // обработка выбора конкретной даты в календаре
                    selectedDay = date.getDate();

                    let params = {
                        YEAR: date.getFullYear(),
                        MONTH: (date.getMonth() + 1).toString().padStart(2, '0'),
                    };

                    if (selectedDay) {
                        params['DAY'] = selectedDay;
                    }

                    if (tagId) {
                        params['TAG'] = tagId;
                    }

                    getNews(params);
                }
            });

            /**
             * Заполнение данных из урла
             */
            if (Object.keys(getUrlParams()).length) {
                const data = getUrlParams();
                let selectedYear = typeof data['YEAR'] !== "undefined" ? data['YEAR'] : null;
                const $yearSelect = $('.js-select2.calendar-filter-year');
                if (selectedYear && $yearSelect.find('[value="' + selectedYear + '"]').length) {
                    $yearSelect.val(selectedYear).trigger('change.select2');
                }

                let selectedMonth = typeof data['MONTH'] !== "undefined" ? data['MONTH'] : null;
                const $monthSelect = $('.js-select2.calendar-filter-month');
                if (selectedMonth && $monthSelect.find('[value="' + selectedMonth + '"]').length) {
                    $monthSelect.val(selectedMonth - 1).trigger('change.select2');
                }

                const dayFromParams = typeof data['DAY'] !== "undefined" ? data['DAY'] : '01';

                let datepicker = $self.data('datepicker');
                if (selectedYear && selectedMonth && typeof datepicker !== 'undefined') {
                    selectedYear = getSelectedYear();
                    selectedMonth = getSelectedMonth();
                    datepicker.date = new Date(`${selectedYear}-${selectedMonth}-${dayFromParams}`);
                }
            }

            /**
             * Выбор тэга
             */
            $(document).on('click', '.js-tag-link', function (e) {
                e.preventDefault();

                const activeClass = 'active';

                if ($(this).hasClass(activeClass)) {
                    tagId = null;
                } else {
                    tagId = $(this).data('tagid');
                }

                const $links = $('.js-tag-link');

                $links.removeClass(activeClass);

                if (tagId) {
                    $links.filter('[data-tagid="' + tagId + '"]').addClass(activeClass);
                }

                let params = {
                    YEAR: getSelectedYear(),
                    MONTH: getSelectedMonth()
                };

                if (selectedDay) {
                    params['DAY'] = selectedDay;
                }

                if (tagId) {
                    params['TAG'] = tagId;
                }

                getNews(params);
            });
        };

        init();
    }
};
